// Shared helpers for reason codes and relevance-gate skips.
//
// The five reject reason codes mirror agentic-anomaly-healing. A job the relevance
// gate stopped (enforce mode) ends as status REJECTED with result "SKIPPED — <code>"
// and review_context.skipped_by_gate. It is not a human rejection, so the UI shows
// it as "Skipped (<code>)" without a new status value.

export const REASON_CODES = [
  { value: 'duplicate', label: 'Duplicate' },
  { value: 'false_positive', label: 'False positive' },
  { value: 'unfixable', label: 'Unfixable' },
  { value: 'bad_fix', label: 'Bad fix' },
  { value: 'other', label: 'Other' },
];

const SKIPPED_RESULT_RE = /^\s*SKIPPED\s*[—–-]\s*([A-Za-z0-9_]+)?/;

export function skippedGateCode(job) {
  if (!job || String(job.status || '').toLowerCase() !== 'rejected') return null;
  const ctx = job.review_context || {};
  const flagged = ctx.skipped_by_gate === true || String(ctx.skipped_by_gate).toLowerCase() === 'true';
  const match = typeof job.result === 'string' ? job.result.match(SKIPPED_RESULT_RE) : null;
  if (!flagged && !match) return null;
  return ctx.skipped_by_gate_code || (match && match[1]) || 'unknown';
}

export const skippedLabel = (code) => `Skipped (${code})`;
